export default __webpack_public_path__ + "static/media/dummy.cfe9f79c.jpg";